import { render } from "./option-item.vue?vue&type=template&id=aa4a19dc&scoped=true"
import script from "./option-item.vue?vue&type=script&lang=js"
export * from "./option-item.vue?vue&type=script&lang=js"

import "./option-item.vue?vue&type=style&index=0&id=aa4a19dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4a19dc"]])

export default __exports__